import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";

// Works both on GitHub Pages (served under /personal-website) and at the root
// (e.g. the Emergent preview). Detect the base path at runtime.
const basename = window.location.pathname.startsWith("/personal-website")
  ? "/personal-website"
  : "";

function App() {
  return (
    <div className="App">
      <BrowserRouter basename={basename}>
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
